export default "__VITE_ASSET__DMS0IA7d__"